var _rect, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResultLoader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "transparent",
      display: "block"
    },
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#0d3cfe",
    x: 15,
    y: 15,
    width: 30,
    height: 30,
    rx: 3,
    ry: 3
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "x",
    dur: "2s",
    repeatCount: "indefinite",
    keyTimes: "0;0.083;0.25;0.333;0.5;0.583;0.75;0.833;1",
    values: "15;55;55;55;55;15;15;15;15",
    begin: "-1.8333333333333333s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    dur: "2s",
    repeatCount: "indefinite",
    keyTimes: "0;0.083;0.25;0.333;0.5;0.583;0.75;0.833;1",
    values: "15;55;55;55;55;15;15;15;15",
    begin: "-1.3333333333333333s"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#00b782",
    x: 15,
    y: 15,
    width: 30,
    height: 30,
    rx: 3,
    ry: 3
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "x",
    dur: "2s",
    repeatCount: "indefinite",
    keyTimes: "0;0.083;0.25;0.333;0.5;0.583;0.75;0.833;1",
    values: "15;55;55;55;55;15;15;15;15",
    begin: "-1.1666666666666667s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    dur: "2s",
    repeatCount: "indefinite",
    keyTimes: "0;0.083;0.25;0.333;0.5;0.583;0.75;0.833;1",
    values: "15;55;55;55;55;15;15;15;15",
    begin: "-0.6666666666666666s"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "#ff4f51",
    x: 15,
    y: 15,
    width: 30,
    height: 30,
    rx: 3,
    ry: 3
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "x",
    dur: "2s",
    repeatCount: "indefinite",
    keyTimes: "0;0.083;0.25;0.333;0.5;0.583;0.75;0.833;1",
    values: "15;55;55;55;55;15;15;15;15",
    begin: "-0.5s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    dur: "2s",
    repeatCount: "indefinite",
    keyTimes: "0;0.083;0.25;0.333;0.5;0.583;0.75;0.833;1",
    values: "15;55;55;55;55;15;15;15;15",
    begin: "0s"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultLoader);
export default __webpack_public_path__ + "static/media/result-loader.16ccbe10937584728def08c48c7dece8.svg";
export { ForwardRef as ReactComponent };